import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import ArticleList from '@src/features/company/articles/ArticleList';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyArticleList() {
  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL]}>
      <CompanyDefaultLayout pageName='articles'>
        <CommonHelmet />
        <ArticleList />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyArticleList;
